import React from "react";
import Home from "../modules/dashboard/pages/Home";
import PaymentAccounts from "../modules/Payment/pages/accounts";
import Notifications from "../modules/Notification/pages/Notifications";
import Developer from "../modules/developer/pages";
import OfflinePage from "../common/OfflinePage";
import { Navigate } from "react-router-dom";
import Login from "../modules/auth/pages/Login";
import Logout from "../modules/auth/pages/Logout";
import ForgotPassword from "../modules/auth/pages/ForgetPassword";
import ProfilePage from "../modules/profile/pages";
import RegisterMerchant from "../modules/auth/pages/registration";
import Company from "../modules/company/pages";
import PaymentsMethodes from "../modules/payements/pages";
import PaymentLink from "../modules/lien-paiement/pages";
import Solde from "../modules/solde/pages";
import Versement from "../modules/versement/pages";
import ComingSoon from "../common/CommingSoon";
import Transactions from "../modules/transactions/pages/Transactions";
import VersementMasse from "../modules/versementmasse/pages";
import UpdateForgotPassword from "../modules/auth/pages/UpdateForgotPassord";
import BusinessManagement from "../modules/admin/business/pages";
import Merchent from "../modules/admin/merchant/pages";
import AllTransactions from "../modules/admin/transaction/pages";
import MerchendDetail from "../modules/admin/merchant/component/merchendDetail";
import BusinessManagementDetail from "../modules/admin/business/component/business-managementDetail";
import CGU from "../modules/auth/component/condition";
import HomeAdmin from "../modules/admin/dashboard/pages/HomeAdmin";
import Commissions from "../modules/admin/parametre-commission/pages";
import Utilisateurs from "../modules/admin/parametre-user/pages";
import DetailCountry from "../modules/dashboard/component/detailCountry";
import NewMerchant from "../modules/merchand/pages/newMerchant";
import FirstBusiness from "../modules/merchand/component/firstBusiness";
// import Transfer from "../modules/transfer/pages";
import Securite from "../modules/admin/parametre-commission/component/securite";
import Roles from "../modules/roles/page";
// import TransfertArgent from "../modules/transfertArgent/pages";
import QRCodeResetSuccess from "../modules/auth/component/qrCodeResetSuccess";
import QRCodeResetError from "../modules/auth/component/qrCodeResetError";
import { Webhook } from "../modules/webhook";
import ProfilePageAdmin from "../modules/profile/pages/index-admin";
import NotificationsAdmin from "../modules/admin/notification/pages";
import Rapport from "../modules/admin/rapport/pages";
import ReconciliationHebdomadaire from "../modules/admin/rapport/component/ReconciliationHebdomadaire";
import ValidationDocs from "../modules/admin/validationdocs/pages";
import SchoolFees from "../modules/school-fees/pages";
import CollectLink from "../modules/collect-link/pages";

const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
const kycVerified = currentUser?.user?.kycVerified;

const authProtectedRoutes = [
  { path: "/new-merchant", component: <NewMerchant /> },
  { path: "/firstbusiness", component: <FirstBusiness /> },
  { path: "/verification-kyc", component: <NewMerchant /> },
  { path: "/bientot", component: <ComingSoon /> },
  { path: "/dashboard", component: <Home /> },
  { path: "/dashboard/detail-country/:id", component: <DetailCountry /> },
  { path: "/dashboard-admin", component: <HomeAdmin /> },
  { path: "*", component: <Navigate to="/dashboard" /> },
  { path: "/compte-versements", component: <PaymentAccounts /> },
  { path: "/notifications", component: <Notifications /> },
  { path: "/business", component: <Developer /> },
  { path: "/profile", component: <ProfilePage /> },
  { path: "/profile-admin", component: <ProfilePageAdmin /> },
  { path: "/offline", component: <OfflinePage /> },
  { path: "/entreprises", component: <Company /> },
  { path: "/methodes-paiements", component: <PaymentsMethodes /> },
  { path: "/payment-link", component: <PaymentLink /> },
  { path: "/collect-link", component: <CollectLink /> },
  { path: "/soldes", component: <Solde /> },
  { path: "/versement", component: <Versement /> },
  { path: "/school-fees", component: <SchoolFees /> },
  { path: "/payout-mass", component: <VersementMasse /> },
  { path: "/transactions", component: <Transactions /> },
  // { path: "/transferts", component: <Transfer /> },
  { path: "/roles", component: <Roles /> },
  // { path: "/transfers", component: <TransfertArgent /> },
  { path: "/webhook", component: <Webhook /> },

  //For admin
  { path: "/business-management", component: <BusinessManagement /> },
  { path: "/marchand", component: <Merchent /> },
  { path: "/marchands/:id", component: <MerchendDetail /> },
  { path: "/business-management/:id", component: <BusinessManagementDetail /> },
  { path: "/transaction-admin", component: <AllTransactions /> },
  { path: "/parametres/commissions", component: <Commissions /> },
  { path: "/parametres/utilisateurs", component: <Utilisateurs /> },
  { path: "/notification-admin", component: <NotificationsAdmin /> },
  { path: "/rapports", component: <Rapport /> },
  {
    path: "/rapports/reconciliation-hebdomadaire",
    component: <ReconciliationHebdomadaire />,
  },
  { path: "/parametres/securites", component: <Securite /> },
  { path: "/validations-documents", component: <ValidationDocs /> },
];

const publicRoutes = [
  { path: "/register-merchant", component: <RegisterMerchant /> },
  { path: "/logout", component: <Logout /> },
  { path: "/login-merchant", component: <Login /> },
  { path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/update/forgot-password", component: <UpdateForgotPassword /> },
  { path: "/offline", component: <OfflinePage /> },
  { path: "/terms-and-conditions", component: <CGU /> },
  { path: "/authenticator/reset/success", component: <QRCodeResetSuccess /> },
  { path: "/authenticator/reset/error", component: <QRCodeResetError /> },
];
export { authProtectedRoutes, publicRoutes };
